// extracted by extract-css-chunks-webpack-plugin
module.exports = {"productTitle":"nW9mi","header-3":"pmMM6","small":"nztQb","primaryProductTitle":"EvWhO"};